import Logo from '@/components/Logo/Logo'
import { createFileRoute } from '@tanstack/react-router'
import type { LucideIcon } from 'lucide-react'
import { CREDIT_ROUTES, toStaticData } from './credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit')({
  staticData: { ...toStaticData(CREDIT_ROUTES['/credit']), icon: Logo as unknown as LucideIcon },
  beforeLoad: async ({ context }) => {
    context.assertModuleAccess('credit')
    context.handleRoutePermissions(Route)
  },
})
